<div class="custom-filter-wrapper">
  <div class="col-md-12 col-sm-12 d-flex p-1 report-alert" *ngIf="alertShow">
    <kl-alert
      [message]="alertMessage"
      type="error"
      [show]="alertShow"
      (onClose)="closeAlert()"
    ></kl-alert>
  </div>
  <div class="custom-filter-inner col-md-12 col-sm-12">
    <div class="filter-options col-md-3 p-0">
      <div class="search-filter-form">
        <div class="search-filter-form-heading" *ngIf="showBottomButtons">
          <div class="button-group">
            <button class="btn btn-sm btn-info" (click)="commitFilter()">
              <i class="fal fa-check-circle"></i>&nbsp;{{ "apply" | translate }}
            </button>
            <button class="btn btn-sm btn-bluefish" (click)="clearAll()">
              <i class="fal fa-minus-circle"></i>&nbsp;{{
                "do_reset" | translate
              }}
            </button>
            <button class="btn btn-sm btn-default ml-2" (click)="closeFilter()">
              <i class="fal fa-times-circle"></i>&nbsp;{{ "close" | translate }}
            </button>
          </div>
        </div>
        <div class="search-filter-form-content">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
    <div class="filter-values col-md-9 row ml-0">
      <div class="filter-values-header" *ngIf="showBottomButtons"></div>
      <div class="filter-values-content col-md-5 col-sm-12 p-0">
        <div class="description">
          <h6 class="font-weight-light mb-0">
            {{ "filter_values" | translate }}
          </h6>
        </div>
        <ul class="filter-list col-md-12 col-sm-12" style="max-height: 65vh">
          <li
            class="col-md-12 col-sm-12"
            *ngFor="let item of selectedFilterValues; let i = index"
          >
            <div class="values">
              <span class="key">{{ item.label | translate }} : </span>
              <span class="value" *ngIf="isArray(item.value)">
                <span *ngFor="let val of item.value; let i = index">
                  <i *ngIf="i > 0">, </i>
                  {{ get(val, item.accessor) | translate }}
                </span>
              </span>
              <span class="value" *ngIf="!isArray(item.value)">
                <span *ngIf="isDate(item.value)">
                  {{ convertDate(item.value) }}
                </span>
                <span *ngIf="!isDate(item.value)">
                  <span *ngIf="item.accessor">
                    {{ get(item.value, item.accessor) | translate }}
                  </span>
                  <span *ngIf="!item.accessor">
                    {{ item.value | translate }}
                  </span>
                </span>
              </span>
            </div>
            <div
              class="tooltip-overlay"
              [tooltip]="getTranslated(item.value, item.accessor)"
              container="body"
            ></div>
            <a role="button" class="close" (click)="deleteFromValues(i, item)">
              <i class="fal fa-trash-alt"></i>
            </a>
          </li>
        </ul>
      </div>
      <div class="col-md-1 filter-vertical-line"></div>
      <div class="filter-values-content col-md-6" *ngIf="showSavedFilters">
        <div class="description">
          <h6 class="font-weight-light mb-0">
            {{ "saved_filters" | translate }}
          </h6>
        </div>
        <div class="filter-list" style="max-height: 60%">
          <div
            class="saved-filter-list"
            *ngFor="let item of filterList; let i = index"
            (click)="selectFilter(item)"
          >
            <div
              class="filter-list-item filter-list-item-primary"
              [ngClass]="currentFilter?.id === item.id ? 'active' : ''"
            >
              <div class="filter-list-desc">
                <div
                  class="tooltip-overlay"
                  [tooltip]="item.description"
                  container="body"
                ></div>
                <span class="filter-list-text">{{
                  item.description | translate
                }}</span>
                <br />
                <span class="filter-list-username">
                  <a
                    href="#"
                    class="filter-list-link"
                    *ngIf="item.level === 'APPLICATION'"
                    >{{ "all_user" | translate }}</a
                  >
                  <a
                    href="#"
                    class="filter-list-link"
                    *ngIf="item.level === 'USER'"
                    >{{ "active_user" | translate }}</a
                  >
                </span>
              </div>
              <a
                role="button"
                class="filter-list-actions"
                (click)="deleteSavedFilter(i, item)"
              >
                <i class="fal fa-trash-alt"></i>
              </a>
            </div>
          </div>
        </div>
        <div class="hr col-md-12 col-sm-12"></div>
        <button
          class="btn btn-sm btn-default mb-1"
          (click)="openEntryNameModal('add')"
        >
          {{ "save_new_design" | translate }}
        </button>
        <button
          class="btn btn-sm btn-default mb-1"
          *ngIf="currentFilter"
          (click)="openEntryNameModal('edit', currentFilter)"
        >
          {{ "edit_active_filter" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
<kl-preference-form
  (onSetPreference)="commitSave($event)"
  [saveForm]="saveForm"
></kl-preference-form>
